import request from "@/config/utils/request";

// 列表查询
export function querySupplierMessagePageByOrgId(data) {
  return request({
    url: "/apis/ebs/spc/seek-message/queryMessagePageByOrgId",
    method: "post",
    data
  });
}

// 读取询价站内信
export function readMessage(data) {
  return request({
    url: "/apis/ebs/spc/seek-message/readMessage",
    method: "post",
    data
  });
}

// 站内信详情
export function qrySiteMessageDetail(data) {
  return request({
    url: "/apis/ebs/spc/sitemessage/qrySiteMessageDetail",
    method: "post",
    data
  });
}

// 第一次下载
export function updateFirstDownloadTime(data) {
  return request({
    url: "/apis/ebs/spc/sitemessage/updateFirstDownloadTime",
    method: "post",
    data
  });
}
